var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-img',{attrs:{"src":"background.jpg"}}),_c('v-card-actions',[_c('router-link',{attrs:{"to":"/play"}},[_c('v-btn',{attrs:{"text":""}},[_vm._v("Play!")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }